module.exports = __webpack_public_path__ + "static/media/pasapets-pasaporte.5b59b022.svg";